import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_AIChat = _resolveComponent("AIChat")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openChat && $setup.openChat(...args)))
    }, [
      _createVNode(_component_MenuIcon, {
        type: "ai-chat",
        width: "27",
        height: "27"
      })
    ]),
    _createVNode(_component_AIChat, {
      "is-open": $setup.isOpen,
      onClose: $setup.closeChat
    }, null, 8 /* PROPS */, ["is-open", "onClose"])
  ]))
}